// extracted by css-extract-rspack-plugin
export default {"header":"_86f697b4","h1":"_d7ab9eb2","headerParticle":"_95d558a0","h2":"_4065a2d1"};